/**
 * Gibbs Workflow DAG — Public API
 *
 * @module gibbs/workflow
 */

// Core DAG
export {
    Workflow, createNode, createEdge, resetIdCounters, ExecutionStatus,
} from './Workflow';

// Provenance
export { ProvenanceLog } from './provenance';

// Validation
export { validate } from './validation';

// Builders
export { createFromSequence, createFromActionPlan } from './builders';

// Templates
export { getTemplate, getAllTemplates, createFromTemplate } from './templates';

// Output Mapper
export { resolveInputs } from './outputMapper';

// Step Runner
export { runStep } from './stepRunner';

// Executor
export { executeWorkflow, cancelWorkflow } from './executor';

// Serialization
export { toJSON, fromJSON } from './serialization';

// Summary Export
export {
    toMarkdown, toHTML, toPlainText, downloadFile, copyToClipboard,
} from './summaryExport';

// Summary Generator
export { generateSummary } from './summaryGenerator';

// Workflow Library
export {
    saveWorkflow, listWorkflows, loadWorkflow, deleteWorkflow,
    prepareRerun, getStorageUsage,
} from './workflowLibrary';

// Macro Capture
export {
    startRecording, stopRecording, isRecording,
    parameterize, saveMacro, replayMacro,
    notifyActionDispatched, onActionDispatched, offActionDispatched,
    getVariables, isMacroExcluded, deriveTargetProtein, resolveMacroTarget,
} from './macroCapture';

// Workflow Diff
export { diffWorkflows, formatDiffAsText } from './workflowDiff';
